import React, { useState, useEffect, useCallback } from "react";
import {
  PopoverArrow,
  PopoverContent,
  Box,
  Stack,
  Icon,
  InputGroup,
  Input,
  LinkBox,
  LinkOverlay,
  Heading,
  Text,
  InputRightElement,
  Image,
  PopoverHeader,
  PopoverBody,
} from "@chakra-ui/react";
import { Markup } from "interweave";
import { Index } from "lunr";
import { MdKeyboardReturn } from "react-icons/md";

const SearchModal = (props) => {
  const { initialFocusRef, lunrIndex } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setResults] = useState([]);

  const index = Index.load(lunrIndex.index);
  const searchData = useCallback(
    (e) => {
      setResults([]);

      const query = typeof e === "string" ? e : searchTerm;
      const results = index.search(query.replace("-", "\\-")).map(({ ref }) => {
        return {
          slug: ref,
          ...lunrIndex.store[ref],
        };
      });

      setResults(results);
    },
    [searchTerm, index, lunrIndex]
  );

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        setSearchTerm(event.target.value);
        searchData(event.target.value);
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [searchData]);

  const updateQuery = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <PopoverContent>
      <PopoverArrow />
      <PopoverHeader>
        <InputGroup>
          <Input
            placeholder="Search microPublications..."
            id="Search"
            value={searchTerm}
            onChange={updateQuery}
            ref={initialFocusRef}
          />

          <InputRightElement
            cursor="pointer"
            onClick={searchData}
            children={<Icon as={MdKeyboardReturn} />}
          />
        </InputGroup>
      </PopoverHeader>
      <PopoverBody>
        <Box height="75vh" overflow="auto">
          <Box>Number of articles: {searchResults.length}</Box>
          <Stack>
            {searchResults.map((item) => {
              return (
                <LinkBox
                  as="article"
                  borderWidth="1px"
                  rounded="md"
                  _hover={{ border: "1px solid" }}
                >
                  <Image
                    src={item.image}
                    height="100px"
                    width="100%"
                    objectFit="cover"
                  />
                  <Box>
                    <Heading size="md" my="2">
                      <LinkOverlay
                        href={`/journals/biology/${item.slug.toLowerCase()}`}
                      >
                        <Markup content={item.title} />
                      </LinkOverlay>
                    </Heading>
                    <Text isTruncated>{item.authors}</Text>
                  </Box>
                </LinkBox>
              );
            })}
          </Stack>
        </Box>
      </PopoverBody>
    </PopoverContent>
  );
};

export default SearchModal;
